import styled from 'styled-components'

const FieldContainer = styled.div`
  position: relative;
  width: 100%;
`

export default FieldContainer
